module.exports = __webpack_public_path__ + "static/media/gvNam.46fab8d0.png";